import React from "react";
import BenefitDescription from "./BenefitDescription";
import BenefitImage from "./BenefitImage";

import benefit1 from "../images/benefit-1.svg"
import benefit2 from "../images/benefit-2.svg"
import benefit3 from "../images/benefit-3.svg"

function BenefitSection(props) {

  return (
    <div className="container px-2 md:px-4 lg:px-8 mx-auto my-8 lg:my-16">
      <h3 className="text-3xl leading-8 font-extrabold text-center tracking-tight text-gray-900 sm:text-4xl sm:leading-10">
        Benefits
      </h3>
      <div className="flex flex-col md:flex-row py-12 lg:py-16">
        <BenefitDescription
          heading="Explain Benefit #1"
          fade="right"
          description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
          Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip."
        />
        <BenefitImage fade="left" imageSrc={benefit1} imageWidth="w-5/6 md:w-9/12" />
      </div>
      <div className="flex flex-col-reverse md:flex-row py-12">
        <BenefitImage fade="right" imageSrc={benefit2} imageWidth="w-5/6 md:w-9/12" />
        <BenefitDescription
          fade="left"
          heading="Explain Benefit #2"
          description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
          Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip."
        />
      </div>
      <div className="flex flex-col md:flex-row py-12 lg:py-16">
        <BenefitDescription
          fade="right"
          heading="Explain Benefit #3"
          description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
          Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip."
        />
        <BenefitImage fade="left" imageSrc={benefit3} imageWidth="w-5/6 md:w-9/12" />
      </div>
    </div>
  )
}

export default BenefitSection;
